export enum ClaimScoreApiVersion {
  V2 = 'v2',
  V2_5 = 'v2.5',
}

export type ClaimScoreApiServiceError = {
  message: string;
  status: number;
  response: {
    data: {
      errors: {
        message: string;
      }[];
    };
  };
};
